<template>
  <v-app-bar color="topAppBar" density="comfortable" flat>
    <v-app-bar-title class="text-white font-weight-medium">Manufacturing Partners Portal</v-app-bar-title>

    <v-spacer />

    <template v-if="isAuthenticated">
      <v-btn variant="text" color="white" :to="{ name: 'VendorList' }">Vendors</v-btn>
      <v-btn variant="text" color="white" :to="{ name: 'Profile' }">Profile</v-btn>
      <v-btn variant="text" color="white" :to="{ name: 'Logout' }">Logout</v-btn>
    </template>
    <template v-else>
      <v-btn variant="text" color="white" :to="{ name: 'Login' }">Login</v-btn>
    </template>
  </v-app-bar>
</template>

<script setup lang="ts">
  import { useAuth0 } from '@auth0/auth0-vue';

  const { isAuthenticated } = useAuth0();
</script>
